import { Directive, Input } from '@angular/core';
import * as i0 from "@angular/core";
export class MheCheckboxIndeterminateDirective {
    constructor(el) {
        this.el = el;
    }
    ngOnChanges({ indeterminate }) {
        const is = indeterminate.currentValue;
        this.el.nativeElement.indeterminate = is;
    }
}
MheCheckboxIndeterminateDirective.ɵfac = function MheCheckboxIndeterminateDirective_Factory(t) { return new (t || MheCheckboxIndeterminateDirective)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
MheCheckboxIndeterminateDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: MheCheckboxIndeterminateDirective, selectors: [["input", "type", "checkbox", "indeterminate", ""]], inputs: { indeterminate: "indeterminate" }, features: [i0.ɵɵNgOnChangesFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MheCheckboxIndeterminateDirective, [{
        type: Directive,
        args: [{
                selector: 'input[type="checkbox"][indeterminate]',
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, { indeterminate: [{
            type: Input
        }] }); })();
